module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-1.c57b0e5a.jpg";